__turbopack_context__.v({
  "caughtUpTitle": "styles-module-scss-module___F2B3q__caughtUpTitle",
  "chip": "styles-module-scss-module___F2B3q__chip",
  "chipsLabel": "styles-module-scss-module___F2B3q__chipsLabel",
  "chipsRow": "styles-module-scss-module___F2B3q__chipsRow",
  "message": "styles-module-scss-module___F2B3q__message",
  "panel": "styles-module-scss-module___F2B3q__panel",
});
